import { useEffect, useState } from "react";

export const useApiData = (fetcher, params = {}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const key = JSON.stringify(params);

  useEffect(() => {
    let active = true;
    setLoading(true);
    fetcher(JSON.parse(key))
      .then((res) => active && setData(res.data))
      .catch(() => active && setData([]))
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, [fetcher, key]);

  return { data, loading };
};

export default useApiData;
